module.exports = __webpack_public_path__ + "media/next-parcours-unlocked.2e8814f4.mp3";